module.exports = __webpack_public_path__ + "img/ame.d957297.svg";